// ============================================================
// EL MOTIVO DE ENTREGA, EN CASTELLANO Y EN UN SOLO SITIO
// ============================================================
//
// POR QUÉ EXISTE. El 11-10-2026 el anuncio del club salió con «Ha sonado en 0
// de 90 móviles» y el desglose decía
//
//     gym_send_push_network_error: 60
//
// La palabra «red» mandó a buscar la URL, la cabecera de autorización y el
// gateway. No era nada de eso: era el límite de Supabase para llamadas
// función→función —30 por ventana de 60 s y por traza— y el `fetch` lanzaba
// antes de salir, así que el `catch` de red le ponía su etiqueta.
//
// **Un parte que nombra mal el fallo es peor que uno que no lo nombra, porque
// dirige la búsqueda al sitio equivocado.** Media noche se fue en eso.
//
// ⚠️ LO QUE NO SE MAPEA SE ENSEÑA TAL CUAL. El respaldo devuelve la clave
// cruda, y es deliberado: un motivo nuevo que esta tabla no conozca tiene que
// VERSE, no desaparecer detrás de un «otro». Esconder un código desconocido es
// la misma enfermedad con otra cara.

const TEXTOS: Record<string, string> = {
  // Saltos legítimos: no se arreglan desplegando nada.
  no_push_token: 'no tiene la app instalada',
  disabled_global: 'tiene los avisos apagados',
  disabled_by_user: 'ha apagado este tipo de aviso',
  device_not_registered: 'su móvil ya no acepta avisos (app desinstalada)',
  no_recipients: 'no hay ningún móvil al que avisar',

  // Fallos de entrega: estos SÍ se arreglan.
  gym_send_push_rate_limited: 'SE PASÓ DEL LÍMITE de llamadas (no es la red)',
  gym_send_push_network_error: 'no se pudo contactar con el servicio de avisos',
  expo_network_error: 'no se pudo contactar con Expo',
  lote_sin_resultados: 'el servicio de avisos contestó algo que no cuadra',
  mensaje_incompleto: 'el aviso iba sin título o sin cuerpo (fallo nuestro)',
};

/**
 * Lo que se le enseña a una persona para un `reason` del parte.
 *
 * Los `push_http_*` se resuelven por patrón: son «respondió con un código N», y
 * tenerlos uno a uno sería una lista que se queda corta el día que aparezca un
 * 502.
 */
export function textoDelMotivo(motivo: string): string {
  const conocido = TEXTOS[motivo];
  if (conocido) return conocido;

  const http = /^push_http_(\d{3})$/.exec(motivo);
  if (http) return `el servicio de avisos respondió ${http[1]}`;

  const expo = /^expo_http_(\d{3})$/.exec(motivo);
  if (expo) return `Expo respondió ${expo[1]}`;

  // El respaldo: la clave, tal cual. Ver la cabecera.
  return motivo;
}

/** El desglose del parte: «motivo (texto): N», en una línea. */
export function desgloseDeMotivos(
  motivos: Record<string, number>,
  separador = ', ',
): string {
  return Object.entries(motivos)
    .map(([motivo, n]) => `${textoDelMotivo(motivo)}: ${n}`)
    .join(separador);
}
